import React, { useEffect, useState } from "react";
import api, { asArray } from "../../lib/api";

export default function AdminContacts() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/admin/contacts").then((r) => setItems(asArray(r.data, "contacts"))).catch(() => {}); }, []);
    return (
        <div data-testid="admin-contacts-page">
            <h1 className="heading text-3xl tracking-tight mb-6">Contact Messages</h1>
            <div className="bg-white">
                <table className="w-full text-sm">
                    <thead className="bg-[#EFF0F1] text-left text-xs uppercase tracking-[0.2em] text-[#6B7280]"><tr><th className="p-4">Name</th><th className="p-4">Email</th><th className="p-4">Subject</th><th className="p-4">Message</th><th className="p-4">Date</th></tr></thead>
                    <tbody>
                        {items.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-[#6B7280]">No messages yet</td></tr>}
                        {items.map((c) => (
                            <tr key={c.id} className="border-t border-black/5">
                                <td className="p-4 heading">{c.name}</td>
                                <td className="p-4 text-[#0060A7]">{c.email}</td>
                                <td className="p-4 text-[#6B7280]">{c.subject || "—"}</td>
                                <td className="p-4 text-[#374151] max-w-md whitespace-pre-wrap">{c.message}</td>
                                <td className="p-4 text-xs text-[#6B7280]">{(c.created_at || "").slice(0, 10)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
